export const linkStyle = { position: 'relative' };
